import React from 'react';
import StatusPill from '../StatusPill';

export interface TableColumn {
  label: string;
  accessor: string;
  render?: (value: any, rowData?: any) => React.ReactNode;
  sortable?: boolean;
  minWidth?: string;
}

export const createJobsiteColumns = (
  handleJobsiteClick: (id: string) => void,
  isJobsiteOffline: (jobsiteDetails: any) => boolean
): TableColumn[] => [
  {
    label: 'Jobsite',
    accessor: 'jobsite',
    sortable: true,
    render: (value: { id: string; name: string }) => (
      <div className="flex flex-row justify-between items-center">
        <div style={{ flexDirection: 'row' }}>
          <span>{value.name} </span>
          {isJobsiteOffline(value) && <span className="text-[red] font-semibold">(New)</span>}
        </div>
      </div>
    )
  },
  {
    label: 'Address',
    accessor: 'address',
    render: (value: string, rowData: any) => {
      const fullAddress = rowData?.originalAddress || value;
      return <span title={fullAddress}>{value}</span>;
    }
  },
  { label: 'Province', accessor: 'province', sortable: true },
  { label: 'General Contractor', accessor: 'contractor', sortable: true },
  {
    label: 'Status',
    accessor: 'status',
    sortable: true,
    render: (value: string) => <StatusPill status={value} />
  },
  { label: 'Completion', accessor: 'completion' },
  { label: 'Submitted by', accessor: 'createdBy', sortable: true }
]; 